import get from 'lodash/get'
import React from 'react'
import { connect } from 'react-redux'
import type { User } from 'types/user'
import { sendMixpanelEvent } from '@disco/state-management/actions/AnalyticsActions'
import { changePassword } from '@disco/state-management/actions/UserActions'
import ChangePassword from 'components/common/change-password'
import DocumentHeadTags from 'components/document-head-tags'
import PageContainer from 'components/ui/page-container'
import PageHeader from 'components/ui/page-header'
import { withTranslation } from '@disco/i18n/with-translation'
import type { WithTranslation } from '@disco/i18n/with-translation'

function mapStateToProps(state) {
  return {
    user: state.user,
  }
}

const mapDispatchToProps = {
  sendMixpanelEvent,
  changePassword,
}
type Props = {
  user: User
} & typeof mapDispatchToProps &
  WithTranslation

class SecuritySettings extends React.Component<Props> {
  componentDidMount() {
    this.props.sendMixpanelEvent('Open Security tab in settings')
  }

  _onPasswordChange = (newPassword: string, oldPassword: string) => {
    this.props.changePassword(newPassword, oldPassword)
  }

  render() {
    const { t } = this.props
    const { business, passwordChanging, passwordChangeError } = this.props.user
    const passwordStrength = get(
      business,
      'public_metadata.password_strength',
      'standard',
    )
    return (
      <>
        <DocumentHeadTags
          title={t(
            'accounts:settingsSecurityDisco',
            'Settings | Security | DISCO',
          )}
        />
        <PageHeader title={t('accounts:changePassword', 'Change password')} />
        <PageContainer>
          <form className="Admin_Section">
            <ChangePassword
              type="settings"
              passwordStrength={passwordStrength}
              passwordChangeInProgress={passwordChanging}
              passwordChangeError={passwordChangeError}
              onPasswordChange={this._onPasswordChange}
            />
          </form>
        </PageContainer>
      </>
    )
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation('accounts')(SecuritySettings)) as any
